import React from "react";
import PropTypes from "prop-types";

const CardLongContentCategory = ({
  category = "Webisode",
  imgSrc = "",
  imgAlt = "",
  className = ""
}) => {
  return (
    <div className={`card__category ${className}`}>
      {imgSrc && <img src={imgSrc} alt={imgAlt} width="24" height="24" />}

      {category}
    </div>
  );
};

CardLongContentCategory.propTypes = {
  className: PropTypes.string,
  category: PropTypes.string,
  imgSrc: PropTypes.string,
  imgAlt: PropTypes.string
};

export default CardLongContentCategory;
